import * as React from 'react';
import { Layouts, NewbuildingLayoutsContext } from '@cian/frontend-newbuilding-layouts-widget';
import { useDispatch, useSelector } from 'react-redux';
import { selectHouseId } from '../../actions/offers';
import { AgentsOffersRow } from '../../components/AgentsOffersRow';
import { getHouseHasLayouts, getNewbuildingId } from '../../selectors/newbuilding';
import { getSelectedHouseId, getLayoutsRoomsCountsByHouse, getOffers } from '../../selectors/offers';
import { BuilderOffersNotAvailable } from '../BuilderOffersNotAvailable';
import { useApplicationContext } from '../../utils/applicationContext';

export const LayoutsContainer = () => {
  const dispatch = useDispatch();

  const selectedHouseId = useSelector(getSelectedHouseId);
  const newbuildingId = useSelector(getNewbuildingId);
  const roomsCountList = useSelector(getLayoutsRoomsCountsByHouse);
  const isHouseLayoutsAvailable = useSelector(getHouseHasLayouts);
  const { fromDeveloperRooms, fromAgentsPropsCountUrl, fromAgentsPropsCountDisplay } = useSelector(getOffers);

  const { httpApi, logger } = useApplicationContext();

  const contextValue = React.useMemo(() => ({ httpApi, logger }), [httpApi, logger]);

  const onHouseFilterReset = React.useCallback(() => {
    dispatch(selectHouseId(undefined));
  }, []);

  if (!fromDeveloperRooms || fromDeveloperRooms.length === 0) {
    return (
      <>
        <BuilderOffersNotAvailable />
        {fromAgentsPropsCountDisplay && (
          <AgentsOffersRow
            fromAgentsPropsCountDisplay={fromAgentsPropsCountDisplay}
            fromAgentsPropsCountUrl={fromAgentsPropsCountUrl as string}
          />
        )}
      </>
    );
  }

  return (
    <div data-testid="offers-layouts">
      <NewbuildingLayoutsContext.Provider value={contextValue}>
        <Layouts
          newbuildingId={newbuildingId}
          houseId={selectedHouseId}
          pageTypeJK="Normal"
          isHouseLayoutsAvailable={isHouseLayoutsAvailable}
          roomsCountList={roomsCountList}
          onHouseFilterReset={onHouseFilterReset}
        />
      </NewbuildingLayoutsContext.Provider>
    </div>
  );
};
